import React from 'react';
import { useIntl } from 'react-intl';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './AboutPage.module.css';
import about1 from './about1.png';
import about2 from './about2.png';
import about3 from './about3.png';

const AboutPage = props => {
  const { location } = props;
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const intl = useIntl();

  const isContactPage = location?.hash === '#contact';

  // SEO Keywords
  const primaryKeywords = isContactPage ? [
    "Host4Euro contact",
    "Contact Host4Euro team",
    "Host4Euro support",
    "Kirche und Sport contact",
    "Technical support Host4Euro"
  ] : [
    "About Host4Euro",
    "Free accommodation Euro 2024",
    "Host4Euro platform",
    "Churchpool",
    "Evangelical Church in Germany (EKD)"
  ];

  const secondaryKeywords = isContactPage ? [
    "Host4Euro email support",
    "Accommodation inquiries Euro 2024",
    "Host4Euro technical questions",
    "Create accommodation listing",
    "Contact listing author"
  ] : [
    "European Football Championship 2024",
    "Real-time accommodation booking",
    "Unbureaucratic accommodation service",
    "Free accommodation listings",
    "Churchpool digital platform",
    "Ecumenical accommodation platform",
  ];

  // Schema for search engines (helps them to understand what this page is about)
  const siteTitle = config.siteTitle;
  const schemaTitle = isContactPage ?
    intl.formatMessage({ id: 'ContactPage.schemaTitle' }, { siteTitle })
    : intl.formatMessage({ id: 'AboutPage.schemaTitle' }, { siteTitle });

  const schemaDescription = isContactPage ?
    intl.formatMessage({ id: 'AboutPage.schemaDescription' }, { siteTitle })
    : intl.formatMessage({ id: 'ContactPage.schemaDescription' }, { siteTitle });



  if (isContactPage) {
    return (
      <StaticPage
        title={schemaTitle}
        description={schemaDescription}
        primaryKeywords={primaryKeywords}
        secondaryKeywords={secondaryKeywords}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ContactPage',
          name: schemaTitle,
          description: schemaDescription,
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.staticPageWrapper}>
            <center>
              <h1>
                <FormattedMessage id="ContactPage.contactTitle" />
              </h1>
            </center>
            <p>
              <FormattedMessage id="ContactPage.contactText1" />
              <a href="mailto:kircheundsport@ekd.de">
                <FormattedMessage id="ContactPage.contactText1Link" />
              </a>
            </p>
            <p>
              <FormattedMessage id="ContactPage.contactText2" />
              <a href="mailto:contact@host4euro.com">
                <FormattedMessage id="ContactPage.contactText2Link" />
              </a>
            </p>
            <p>
              <FormattedMessage id="ContactPage.contactText3Part1" />
              <a href="/faq">
                <FormattedMessage id="ContactPage.contactText3Link" />
              </a>
              <FormattedMessage id="ContactPage.contactText3Part2" />
            </p>
            <p>
              <FormattedMessage id="ContactPage.contactText4Part1" />"
              <a href="/l/draft/00000000-0000-0000-0000-000000000000/new/features">
                <FormattedMessage id="ContactPage.contactText4Link" />
              </a>
              "
              <FormattedMessage id="ContactPage.contactText4Part2" />
            </p>
            <p>
              <FormattedMessage id="ContactPage.contactText5" />
            </p>
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </StaticPage>
    );
  }
  // prettier-ignore
  return (
    <StaticPage
      title={schemaTitle}
      description={schemaDescription}
      primaryKeywords={primaryKeywords}
      secondaryKeywords={secondaryKeywords}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <center>
            <h1>
              <FormattedMessage id="AboutPage.aboutTitle1" />
            </h1>
          </center>
          <img src={about1} className={css.coverImage} />

          <p>
            <FormattedMessage id="AboutPage.aboutText1Part1" />
            <a href="https://www.churchpool.com/de/">
              <FormattedMessage id="AboutPage.aboutText1Link1" />
            </a>
            <FormattedMessage id="AboutPage.aboutText1Part2" />
            <a href="https://www.ekd.de">
              <FormattedMessage id="AboutPage.aboutText1Link2" />
            </a>
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText2" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText3" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText4Part1" />
            <br />
            <FormattedMessage id="AboutPage.aboutText4Part2" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText5Part1" />
            <br />
            <a href="/how-it-works">
              <FormattedMessage id="AboutPage.aboutText5Link1" />
            </a>
            <FormattedMessage id="AboutPage.aboutText5Part2" />
          </p>

          <center>
            <h1>
              <FormattedMessage id="AboutPage.aboutTitle2" />
            </h1>
          </center>
          <img src={about2} className={css.coverImage} />

          <p>
            <FormattedMessage id="AboutPage.aboutText6" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText7" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText8" />
          </p>
          <p>
            <FormattedMessage id="AboutPage.aboutText9" />
            <a href="https://www.churchpool.com/de/">
              <FormattedMessage id="AboutPage.aboutText9Link1" />
            </a>
          </p>

          <img src={about3} className={css.coverImage} />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
